import { AccountsPermissions } from './accounts.permissions';
import { AccountsRoles } from './accounts.roles';

export const accountsMappings = {
  [AccountsPermissions.GET_ACCOUNT]: [AccountsRoles.VIEWER],
  [AccountsPermissions.GET_USERS]: [AccountsRoles.USERS_VIEWER],
  [AccountsPermissions.GET_DETAILED_USERS]: [
    AccountsRoles.DETAILED_USERS_VIEWER,
  ],
  [AccountsPermissions.INVITE_USER]: [AccountsRoles.EDITOR],
  [AccountsPermissions.DEACTIVATE_USER]: [AccountsRoles.EDITOR],
  [AccountsPermissions.REACTIVATE_USER]: [AccountsRoles.EDITOR],
  [AccountsPermissions.UPDATE_ROLE]: [
    AccountsRoles.EDITOR,
    AccountsRoles.USERS_ROLE_EDITOR,
  ],

  [AccountsPermissions.GET_TEAMS]: [AccountsRoles.TEAMS_VIEWER],
  [AccountsPermissions.MANAGE_TEAMS]: [AccountsRoles.EDITOR],
  [AccountsPermissions.MANAGE_TEAM_MEMBERS]: [
    AccountsRoles.EDITOR,
    AccountsRoles.TEAM_MEMBERS_MANAGER,
  ],

  [AccountsPermissions.GET_EMAIL_TEMPLATES]: [
    AccountsRoles.EMAIL_TEMPLATE_VIEWER,
  ],
  [AccountsPermissions.MANAGE_EMAIL_TEMPLATES]: [
    AccountsRoles.EMAIL_TEMPLATE_MANAGER,
  ],
  [AccountsPermissions.UPDATE_SUBSCRIPTION]: [
    AccountsRoles.SUBSCRIPTION_EDITOR,
  ],
  [AccountsPermissions.UPDATE_ACCOUNT]: [AccountsRoles.EDITOR],
  [AccountsPermissions.UPDATE_MY_ACCOUNT]: [AccountsRoles.PERSONAL_EDITOR],
  [AccountsPermissions.GET_USER_COST_PER_HOUR]: [
    AccountsRoles.USERS_COST_PER_HOUR_VIEWER,
  ],
  [AccountsPermissions.SET_USER_COST_PER_HOUR]: [
    AccountsRoles.USERS_COST_PER_HOUR_EDITOR,
  ],
  [AccountsPermissions.SET_USER_COLOUR]: [
    AccountsRoles.EDITOR,
    AccountsRoles.USERS_COLOUR_EDITOR,
  ],

  [AccountsPermissions.SET_CUSTOM_EMAIL_DOMAIN]: [
    AccountsRoles.CUSTOM_EMAIL_DOMAIN_EDITOR,
  ],
  [AccountsPermissions.SEND_FROM_CUSTOM_EMAIL_DOMAIN]: [
    AccountsRoles.CUSTOM_EMAIL_DOMAIN_SENDER,
  ],
  [AccountsPermissions.GET_CUSTOM_FIELD_GROUPS]: [
    AccountsRoles.CUSTOM_FIELD_GROUP_VIEWER,
  ],
  [AccountsPermissions.GET_FIELD_SERVICE_SELF_ASSIGNABLE_CUSTOM_FIELDS]: [
    AccountsRoles.SELF_ASSIGNED_CUSTOM_FIELD_TASK_CREATOR,
  ],
  [AccountsPermissions.MANAGE_CUSTOM_FIELD_GROUPS]: [
    AccountsRoles.CUSTOM_FIELD_GROUP_MANAGER,
  ],
  [AccountsPermissions.MANAGE_CUSTOM_FIELD_VALUES]: [
    AccountsRoles.CUSTOM_FIELD_VALUE_MANAGER,
  ],
  [AccountsPermissions.MANAGE_TAGS]: [AccountsRoles.TAG_MANAGER],

  [AccountsPermissions.VIEW_CHILD_ACCOUNTS]: [
    AccountsRoles.CHILD_ACCOUNTS_VIEWER,
  ],
  [AccountsPermissions.JOIN_CHILD_ACCOUNT]: [
    AccountsRoles.CHILD_ACCOUNTS_JOINER,
  ],

  [AccountsPermissions.ADD_CONNECTION]: [AccountsRoles.CONNECTION_EDITOR],
  [AccountsPermissions.UPDATE_CONNECTION]: [AccountsRoles.CONNECTION_EDITOR],
  [AccountsPermissions.DELETE_CONNECTION]: [AccountsRoles.CONNECTION_EDITOR],
  [AccountsPermissions.ADD_CONNECTION_ACCOUNTING]: [
    AccountsRoles.CONNECTION_EDITOR,
    AccountsRoles.CONNECTION_ACCOUNTING_EDITOR,
  ],
  [AccountsPermissions.ADD_CONNECTION_SUPPLIERS]: [
    AccountsRoles.CONNECTION_EDITOR,
    AccountsRoles.CONNECTION_SUPPLIERS_EDITOR,
  ],
  [AccountsPermissions.ADD_CONNECTION_PAYMENT]: [
    AccountsRoles.CONNECTION_EDITOR,
    AccountsRoles.CONNECTION_PAYMENT_EDITOR,
  ],
  [AccountsPermissions.ADD_CONNECTION_AUTOMATION]: [
    AccountsRoles.CONNECTION_EDITOR,
    AccountsRoles.CONNECTION_AUTOMATION_EDITOR,
  ],
  [AccountsPermissions.UPDATE_CONNECTION_ACCOUNTING]: [
    AccountsRoles.CONNECTION_EDITOR,
    AccountsRoles.CONNECTION_ACCOUNTING_EDITOR,
  ],
  [AccountsPermissions.UPDATE_CONNECTION_SUPPLIERS]: [
    AccountsRoles.CONNECTION_EDITOR,
    AccountsRoles.CONNECTION_SUPPLIERS_EDITOR,
  ],
  [AccountsPermissions.UPDATE_CONNECTION_PAYMENT]: [
    AccountsRoles.CONNECTION_EDITOR,
    AccountsRoles.CONNECTION_PAYMENT_EDITOR,
  ],
  [AccountsPermissions.UPDATE_CONNECTION_AUTOMATION]: [
    AccountsRoles.CONNECTION_EDITOR,
    AccountsRoles.CONNECTION_AUTOMATION_EDITOR,
  ],
  [AccountsPermissions.DELETE_CONNECTION_ACCOUNTING]: [
    AccountsRoles.CONNECTION_EDITOR,
    AccountsRoles.CONNECTION_ACCOUNTING_EDITOR,
  ],
  [AccountsPermissions.DELETE_CONNECTION_SUPPLIERS]: [
    AccountsRoles.CONNECTION_EDITOR,
    AccountsRoles.CONNECTION_SUPPLIERS_EDITOR,
  ],
  [AccountsPermissions.DELETE_CONNECTION_PAYMENT]: [
    AccountsRoles.CONNECTION_EDITOR,
    AccountsRoles.CONNECTION_PAYMENT_EDITOR,
  ],
  [AccountsPermissions.DELETE_CONNECTION_AUTOMATION]: [
    AccountsRoles.CONNECTION_EDITOR,
    AccountsRoles.CONNECTION_AUTOMATION_EDITOR,
  ],
  [AccountsPermissions.ADD_DESIGN_INTEGRATION]: [
    AccountsRoles.DESIGN_INTEGRATION_EDITOR,
  ],
  [AccountsPermissions.UPDATE_DESIGN_INTEGRATION]: [
    AccountsRoles.DESIGN_INTEGRATION_EDITOR,
  ],
  [AccountsPermissions.DELETE_DESIGN_INTEGRATION]: [
    AccountsRoles.DESIGN_INTEGRATION_EDITOR,
  ],

  [AccountsPermissions.MANAGE_API_KEYS]: [AccountsRoles.API_KEYS_MANAGER],
  [AccountsPermissions.MANAGE_WEBHOOKS]: [AccountsRoles.WEBHOOKS_MANAGER],
  [AccountsPermissions.MANAGE_EXTERNAL_PAYMENT_REDIRECT]: [
    AccountsRoles.EXTERNAL_PAYMENT_REDIRECT_MANAGER,
  ],
};
